/**
 * Insurance eligibility (owner WP4-ELIG, BUILD-PLAN M19): the verification
 * worklist at `/insurance` with the coverage card, benefit diff and accept,
 * phone verification and automated-check settings. Other modules reuse the
 * chip through `./index.ts` (schedule tiles, patient bar, huddle).
 */
import { defineManifest } from '@velora/contracts';
import { defineWebModule } from '../../app/module.js';

export default defineWebModule({
  manifest: defineManifest({
    id: 'eligibility',
    title: 'Insurance eligibility',
    version: '0.1.0',
    owner: 'WP4-ELIG',
    entitlementKey: null,
    permissions: ['insurance.view', 'insurance.edit', 'money.view'],
    routes: [
      {
        id: 'worklist',
        path: '/insurance',
        title: 'Insurance',
        officeScope: 'location-or-all',
        permission: 'insurance.view',
        readsPhi: true,
      },
    ],
    nav: [
      {
        label: 'Insurance',
        group: 'revenue',
        routeId: 'worklist',
        icon: 'shield-check',
        order: 5,
        permission: 'insurance.view',
      },
    ],
    commands: [
      {
        id: 'eligibility.open',
        title: 'Go to Insurance eligibility',
        keywords: ['eligibility', 'verify', 'benefits', 'coverage', 'insurance', '270', '271'],
        routeId: 'worklist',
        permission: 'insurance.view',
      },
    ],
    shortcuts: [{ keys: 'g y', description: 'Go to Insurance eligibility', routeId: 'worklist' }],
    sseEntityKeys: ['eligibility_check'],
  }),
  pages: {
    worklist: () => import('./pages/InsurancePage.js'),
  },
});
